import React from "react";
import { Route, HashRouter } from "react-router-dom";
//import Home from "./components/pages/home";
import About from "./components/pages/about";
import Photography from "./components/pages/photography";
import Projects from "./components/pages/projects";
import Charts from "./components/pages/charts";

function App() {
  return (
    <>
      <HashRouter>
      <Route exact path="/" component={About} />
        <Route
          exact
          path="/publications_and_presentations"
          component={Projects}
        />
        <Route exact path="/charts" component={Charts} />
        <Route exact path="/photography" component={Photography} />

        
      </HashRouter>
    </>
  );
}

export default App;
